import { widgetRuntime } from "./utils/widgetRuntime";

const runtime = widgetRuntime();

if (runtime) {
  __webpack_public_path__ = `${runtime.origin}/`;
  import("./widgets/mcp/start");
} else {
  import(/* webpackMode: "eager" */ "./webStart");
}
